var map = {
	"./activity-budget.svg": 4920,
	"./activity-comments.svg": 8122,
	"./activity-order.svg": 535,
	"./activity-whatsapp.svg": 2739,
	"./arrow-dropdown.svg": 2787,
	"./arrow-gray.svg": 3197,
	"./arrow-right-white.svg": 7978,
	"./arrow.svg": 439,
	"./calendar-light.svg": 4607,
	"./calendar.svg": 4701,
	"./card-company.svg": 4601,
	"./card-date-created-at.svg": 8556,
	"./card-date-updated-at.svg": 6458,
	"./card-location.svg": 3453,
	"./card-origin.svg": 3427,
	"./card-stage-arrow-hover.svg": 2413,
	"./card-stage-arrow.svg": 7248,
	"./card-user.svg": 2182,
	"./close-blue.svg": 2294,
	"./close.svg": 7657,
	"./company.svg": 4764,
	"./config.svg": 3267,
	"./contact.svg": 2582,
	"./copy.svg": 6945,
	"./crm.svg": 4730,
	"./dashboard.svg": 9143,
	"./default.svg": 1681,
	"./delete-small-white.svg": 2823,
	"./delete-small.svg": 77,
	"./delete.svg": 5930,
	"./design.svg": 1343,
	"./drag.svg": 7130,
	"./edit.svg": 1870,
	"./export.svg": 5357,
	"./filter.svg": 5782,
	"./image.svg": 870,
	"./import.svg": 567,
	"./input-preview-back.svg": 8201,
	"./input-preview-cp.svg": 6824,
	"./input-preview-edit.svg": 1044,
	"./input-preview-save.svg": 1945,
	"./loading.svg": 5677,
	"./logo.svg": 9468,
	"./logout.svg": 6082,
	"./order.svg": 44,
	"./pdf.svg": 8415,
	"./people.svg": 4510,
	"./plus-blue.svg": 2215,
	"./plus-circle.svg": 4741,
	"./plus-white.svg": 6430,
	"./product.svg": 6660,
	"./quote.svg": 5080,
	"./save-blue.svg": 2805,
	"./save-white.svg": 9634,
	"./send.svg": 3893,
	"./table.svg": 3961,
	"./task-call-completed.svg": 4242,
	"./task-call-pending.svg": 8392,
	"./task-completed.svg": 5375,
	"./task-email-completed.svg": 3826,
	"./task-email-pending.svg": 1994,
	"./task-meeting-completed.svg": 948,
	"./task-meeting-pending.svg": 8066,
	"./task-task-completed.svg": 2912,
	"./task-task-pending.svg": 445,
	"./update-white.svg": 5021,
	"./upload-small.svg": 3439,
	"./upload.svg": 6800,
	"./user.svg": 3352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7970;